import { render } from "./Installation.vue?vue&type=template&id=3b9a0b43&scoped=true&ts=true"
import script from "./Installation.vue?vue&type=script&lang=ts"
export * from "./Installation.vue?vue&type=script&lang=ts"

import "./Installation.vue?vue&type=style&index=0&id=3b9a0b43&scoped=true&lang=css"

import exportComponent from "/home/muhammadibrahim/Myserver/medix_envato_v4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b9a0b43"]])

export default __exports__